import { supabase } from "../supabase/supabaseClient";

export const getFavorites = async (scoutId) => {
    return await supabase
        .from("favorites")
        .select("id, player_id, created_at")
        .eq("scout_id", scoutId)
        .order("created_at", { ascending: false });
};

export const addFavorite = async (scoutId, playerId) => {
    const payload = { scout_id: scoutId, player_id: playerId };
    try {
        console.log("favoritesService.addFavorite: inserting", payload);
        const res = await supabase
            .from("favorites")
            .insert([payload])
            .select()
            .single();
        if (res.error) console.warn("favoritesService.addFavorite error response:", res.error);
        else console.log("favoritesService.addFavorite success:", res.data);
        return res;
    } catch (e) {
        console.error("favoritesService.addFavorite exception:", e);
        throw e;
    }
};

export const removeFavorite = async (scoutId, playerId) => {
    return await supabase
        .from("favorites")
        .delete()
        .eq("scout_id", scoutId)
        .eq("player_id", playerId);
};
